/**
 * 납품 전 QA(품질 게이트) API.
 *
 * 백엔드 단일 정책 소스(services/delivery_qa.py)를 그대로 소비한다.
 *   GET /jobs/{id}/qa       — 작업 단위 QA
 *   GET /requests/{id}/qa   — 의뢰 단위 QA (하위 작업 합산)
 *
 * severity=block 이 하나라도 있으면 납품용 다운로드를 막고,
 * warn 만 있으면 확인창을 거쳐 진행한다.
 */

import { apiClient } from "./client";

export type QaSeverity = "block" | "warn";

/** 프론트 i18n 키(qa.issue.<code>.*)와 1:1. */
export type QaCode =
  | "same_agent_diff_swift"
  | "billing_party_out_of_range"
  | "billing_party_empty"
  | "ref_number_empty"
  | "ref_number_format"
  | "ref_number_autofixed"
  | "ref_number_no_country"
  | "ref_number_filename_mismatch"
  | "invoice_number_empty"
  | "invoice_date_empty"
  | "swift_withholding_empty"
  | "amount_mismatch"
  | "amount_format";

export interface QaIssueItem {
  file_id: string;
  job_id: string;
  document_id: string;
  detail: string;
}

export interface QaIssueGroup {
  code: QaCode;
  severity: QaSeverity;
  count: number;
  items: QaIssueItem[];
}

export interface QaReport {
  blocking: boolean;
  has_warnings: boolean;
  groups: QaIssueGroup[];
}

export async function getJobQa(jobId: string): Promise<QaReport> {
  const res = await apiClient.get<QaReport>(`/jobs/${jobId}/qa`);
  return res.data;
}

export async function getRequestQa(requestId: string): Promise<QaReport> {
  const res = await apiClient.get<QaReport>(`/requests/${requestId}/qa`);
  return res.data;
}
